(function($, Drupal) {
  Drupal.behaviors.search_form = {
    attach: function(context, settings) {
      $('#search-block-form').attr('action', '/search');
      $('#edit-keys--2').attr('name', 'keyword');
      $('.js-form-item-sort-by select').on('change', function() {
        $(this).closest('form').submit();
      });
    }
  };
})(jQuery, Drupal);